import store from '@/store'
import { Toast } from '@/plugin/vant'

// import checkStarStatus from '@/static/js/checkStar'

import { getQueryStr, getPlatform } from '../static/js/zjs'

/**
 * 在所有路由跳转前拦截，保证在载入页面前获取到必要的用户数据
 * @param {*} router
 * @param {*} options
 *  @property {Boolean}  isSnsapiIserinfo 微信授权链接的scope是否snsapi
 */
export default async function(router, options = {}) {
  const { isSnsapiIserinfo } = options
  /**
   * 弹窗
   */
  let toast = Toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration: 0
  })
  /**
   *  页面加载前，请求必须加载的数据
   */
  try {
    // 获取 appid
    const { appid } = getPlatform()
    // 获得openid
    const { url, openid } = await store.dispatch('user/getOpenid', {
      code: getQueryStr('code', location.search),
      isSnsapiIserinfo
    })
    if (openid) {
      // 基础数据, 以来openid和appid可以并行请求
      const [userInfo, userPref, basicInfo] = await Promise.all([
        store.dispatch('user/updateUserInfo'),
        store.dispatch('user/updateUserPref'),
        store.dispatch('user/updateBasicInfo'),
        store.dispatch('dictionary/getZidian')
      ])
      // 依赖基础数据, 需等基础数据请求完后执行
      await store.dispatch('user/updateTextBookVersion')
      store.appId = appid // ***兼容旧的数据结构***
      store.openid = openid // 兼容旧的数据结构
      store.userInfo = userInfo // 兼容旧的数据结构
      store.userPref = userPref // 兼容旧的数据结构
      store.basicInfo = basicInfo // 兼容旧的数据结构

      // checkStarStatus(openid) // 检查是否关注公众号
      // 向外部广告发数据
      document.dispatchEvent(
        new CustomEvent('userInfo', {
          detail: {
            userInfo,
            userPref,
            basicInfo
          }
        })
      )
      // next()
    } else {
      location.replace(url)
    }
  } catch (e) {
    // 如果有啥报错，将会跳转到错误页面
    router.replace({
      name: 'Error',
      params: { error: e }
    })
  }

  /**
   * 进入页面触发加载中弹窗，首次进入路由后清除
   */

  router.afterEach(() => {
    if (toast) {
      toast.clear()
      toast = null
    }
  })
}
